var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { useRef, useState, useEffect } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import { textContent } from '../../util/childUtil';
import { overflowTooltipPropTypes } from './types';
import NxTooltip from './NxTooltip';
import { any } from 'ramda';
function isOverflowing(el) {
    // inline elements always report 0 clientWidth in standards-compliant browsers. At the same time, inline elements
    // cannot (themselves) overflow.
    return el.clientWidth < el.scrollWidth && getComputedStyle(el).display !== 'inline';
}
function selfOrChildrenOverflowing(el) {
    return isOverflowing(el) || any(selfOrChildrenOverflowing, Array.from(el.children));
}
export default function NxOverflowTooltip(_a) {
    var title = _a.title, children = _a.children, otherProps = __rest(_a, ["title", "children"]);
    var computedTitle = title || textContent(children), _b = useState(false), needsTooltip = _b[0], setNeedsTooltip = _b[1], ref = useRef(null), childrenWithRef = React.cloneElement(children, { ref: ref });
    function updateNeedsTooltip() {
        var el = ref.current;
        setNeedsTooltip(!!el && selfOrChildrenOverflowing(el));
    }
    // check the width on initial layout and any time computedTitle changes
    useEffect(updateNeedsTooltip, [computedTitle]);
    // check the width any time the element resizes
    useResizeObserver(ref, updateNeedsTooltip);
    return (React.createElement(NxTooltip, __assign({}, otherProps, { title: needsTooltip ? computedTitle : '' }), childrenWithRef));
}
NxOverflowTooltip.propTypes = overflowTooltipPropTypes;
//# sourceMappingURL=NxOverflowTooltip.js.map